import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { change } from 'redux-form';
import { CheckoutState } from '../../state';

export const EPHEMERAL_FIELD_NAME = 'FIX-FOR-EB-228399' as const;

const mapStateToProps = (_state: CheckoutState) => ({});

const mapDispatchToProps = (dispatch: Dispatch<CheckoutState>) => ({
    /**
     * This will force redux-form to create a `fields` and a `values` object.
     * Having a `fields` object will avoid a bug where a list of fields that are
     * all numbers creates an array rather than an object.
     *
     * This issue was introduced when we NOS changed attendee IDs from `A-123`
     * form to `123`.
     *
     * See:
     * - Ticket: https://eventbrite.atlassian.net/browse/EB-228399
     * - Github issue: https://github.com/redux-form/redux-form/issues/3753
     */
    createEphemeralField: (formName: string) => {
        dispatch(change(formName, EPHEMERAL_FIELD_NAME, ' ', true));
    },
});

export const connectCreateEphemeralField = connect(
    mapStateToProps,
    mapDispatchToProps,
);
